import React from 'react'
import { useLocation } from 'react-router-dom'
import { useMappingStats } from '../../../../../features/groupCustomerMapping/queries/useMappingStats'
import PairMappingEditor from '../../../../../features/groupCustomerMapping/components/pairMappingEditor/PairMappingEditor'
import Loading from '../../../../../shared/components/Loading'

interface PairLocationState {
  ownerId?: string
  counterpartyId?: string
}

const CustomerMappingPair: React.FC = () => {
  const location = useLocation()
  const { ownerId, counterpartyId } = (location.state ?? {}) as PairLocationState

  const { companies, sourceMaps, rows, isCompaniesLoading, isSourceMapsLoading } = useMappingStats()

  if (isCompaniesLoading) return <Loading />

  return (
    <PairMappingEditor
      companies={companies}
      sourceMaps={sourceMaps}
      rows={rows}
      loading={isSourceMapsLoading}
      initialOwnerId={ownerId}
      initialCounterpartyId={counterpartyId}
    />
  )
}

export default CustomerMappingPair
